import React from "react";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";


const useStyles = makeStyles((theme) => ({
    question1: {
        color: theme.palette.text.primary,
        fontStyle:'italic',
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(1),
        },
        display: 'inline-block',
    },
}));

const CaptionMsg = (props) => {
    const classes = useStyles();
    return (
        <Typography variant="caption" className={classes.question1}>
            {props.message ? props.message : ''}
        </Typography>
    )
}

export default CaptionMsg;